export const getFileUrl = (id: string, agencyId: number) => {
  if (!id || !agencyId) return '';
  return `${process.env.NEXT_PUBLIC_API_URL}/file/${id}?agencyId=${agencyId}`;
};
